import { Currency } from '@/api/types/public';
import { LensIndexItem } from '@/app/[variants]/_lens-components/types';

import {
  handleLensIndexDiscountPercent,
  handleLensIndexPriceInfo,
} from '@/app/[variants]/_lens-components/utils';
import { useStore } from '@/providers/app-store-provider';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import React, { useEffect, useState } from 'react';

export default function Price({
  renderPrice,
  currency,
  currencyName,
  lensIndexItem,
}: {
  renderPrice: (price?: string, sellPrice?: string, discountPercent?: number) => React.ReactNode;
  currency?: Currency;
  currencyName?: string;
  lensIndexItem: LensIndexItem;
}) {
  const currencyList = useStore((state) => state.currencyList);
  const currencyStore = useStore((state) => state.currency);
  const [nowCurrency] = useState<Currency>(
    currency || currencyList.find((item) => item.name === currencyName) || currencyStore,
  );
  const userInfo = useStore((state) => state.userInfo);
  const [nowPrice, setNowPrice] = useState<string>('');
  const [nowSellPrice, setNowSellPrice] = useState<string>('');
  const [discountPercent, setDiscountPercent] = useState<number>(0);
  useEffect(() => {
    if (lensIndexItem) {
      const nowPriceInfo = handleLensIndexPriceInfo(lensIndexItem, nowCurrency, userInfo);

      setNowPrice(nowPriceInfo?.price);
      setNowSellPrice(nowPriceInfo?.sell_price);
      setDiscountPercent(handleLensIndexDiscountPercent(lensIndexItem, userInfo));
    }
  }, [userInfo]);
  return renderPrice(
    nowPrice !== nowSellPrice && nowPrice ? formatPriceNumberWithSymbol(nowPrice, nowCurrency) : '',
    nowSellPrice ? formatPriceNumberWithSymbol(nowSellPrice, nowCurrency) : '',
    discountPercent,
  );
}
